import { ChangeEvent } from "react";

import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { SubscriptionPlanDto } from "@/Common/Models/Portal/ClinicConfig/SubscriptionPlanDto";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import * as LocalOperations from "@/Common/Operations/operations.local";

interface ISubscriptionCreationProps {
    patientContactId: string;
    subscriptionPlans: SubscriptionPlanDto[]
}

class SubscriptionCreationState {
    constructor(fields?: Partial<SubscriptionCreationState>) {
        (Object as any).assign(this, fields);
    }

    public selectedPlanId: string;
    public selectedIntervalId: string;
    public selectedStartDate: Date;
    public intervals: KeyValuePair<string, string>[];
}

class SubscriptionCreation extends BaseReactComponent<ISubscriptionCreationProps, SubscriptionCreationState> {
    public state = new SubscriptionCreationState({
        selectedStartDate: new Date(),
        intervals: []
    });

    public render(): JSX.Element {
        return (
            <div className="flex-container center" style={{ paddingBottom: "10px", alignItems: "center" }}>
                <div className="push-right-5" style={{ minWidth: "200px" }}>
                    <strong>{cacheStore.GetString("CreateLabel")} {cacheStore.GetString("SubscriptionLabel")} : </strong>
                </div>
                <select className="form-control push-right-5" value={this.state.selectedPlanId} onChange={this.changeSelection.bind(this)} style={{ width: "auto", minWidth: "200px" }}>
                    {!this.state.selectedPlanId &&
                        <option />
                    }
                    {this.props.subscriptionPlans.map((p, i) => (
                        <option value={p.SubscriptionPlanId} key={"planOpt_" + i}>{p.Name}</option>
                    ))}
                </select>
                <select
                    disabled={!this.state.intervals || !this.state.intervals.length}
                    className="form-control push-right-5"
                    style={{ width: "auto", minWidth: "200px" }}
                    value={this.state.selectedIntervalId}
                    onChange={this.changeInterval.bind(this)}
                >
                    {this.state.intervals && this.state.intervals.map((interval, index) => (
                        <option key={"int_" + index} value={interval.Value}>{interval.Key}</option>
                    ))}
                </select>
                <DateSelector
                    cssClass="push-right-5"
                    date={this.state.selectedStartDate}
                    dateFormat="yyyy-MM-dd"
                    id="createSubscription_startDate"
                    onChangeCallback={this.changeStartDate.bind(this)}
                />
                <button disabled={IsNullOrWhiteSpace(this.state.selectedPlanId)} className="btn btn-primary push-right-5" onClick={this.createSubscriptionClick.bind(this)}>
                    <span>{cacheStore.GetString("CreateLabel")}</span>
                </button>
            </div>
        );
    }

    private changeSelection(e: ChangeEvent<HTMLSelectElement>): void {
        const selectedPlan = this.props.subscriptionPlans.firstOrDefault(plan => plan.SubscriptionPlanId === e.target.value);

        this.mutateState(s => {
            s.intervals = [];

            if (selectedPlan) {
                s.selectedPlanId = selectedPlan.SubscriptionPlanId;

                if (selectedPlan && selectedPlan.MonthlyRate) {
                    s.intervals.push(new KeyValuePair(cacheStore.GetString("MonthlyMasculineLabel"), "2"));
                    s.selectedIntervalId = "2";
                }
                if (selectedPlan && selectedPlan.AnnualRate) {
                    s.intervals.push(new KeyValuePair(cacheStore.GetString("YearlyMasculineLabel"), "3"));
                    if (!s.selectedIntervalId)
                        s.selectedIntervalId = "3";
                }
                if (selectedPlan && selectedPlan.LifetimeRate) {
                    s.intervals.push(new KeyValuePair(cacheStore.GetString("LifetimeLabel"), "1"));
                    if (!s.selectedIntervalId)
                        s.selectedIntervalId = "1";
                }
            }
            else {
                s.selectedPlanId = null;
                s.selectedIntervalId = null;
            }
        });
    }

    private changeInterval(e: ChangeEvent<HTMLSelectElement>): void {
        const selectedIntervalId = e.target.value;

        this.mutateState(s => {
            s.selectedIntervalId = selectedIntervalId;
        });
    }

    private changeStartDate(date: Date): void {
        this.mutateState(s => {
            s.selectedStartDate = date;
        });
    }

    private createSubscriptionClick(): void {
        sessionStore.dispatch(
            LocalOperations.Portal.Subscription_Create,
            {
                planId: this.state.selectedPlanId,
                intervalId: parseInt(this.state.selectedIntervalId),
                startDate: this.state.selectedStartDate,
                patientId: this.props.patientContactId
            },
            150
        );
    }
}

export { SubscriptionCreation };
